import React from 'react';
import styles from'./Account.module.scss';
import ClinicDetails from "../../../components/ClinicDetails/ClinicDetails";
import LoginsManager from "../../../components/LoginsManager/LoginsManager";
import OpeningHours from "../../../components/OpeningHours/OpeningHours";
import TreatmentSettings from "../../../components/TreatmentSettings/TreatmentSettings";
import AssignmentRequests from "../../../components/AssignmentRequests/AssignmentRequests";
import AccountDetails from "../../../components/AccountDetails/AccountDetails";
import AccountUsersTable from "../../../components/AccountUsersTable/AccountUsersTable";
import HasPermission from 'helpers/permissions/HasPermission';
import EmailPreferencesWidget from "components/EmailPreferences/EmailPreferencesWidget";

class ClinicAccount extends React.Component {
    render() {
        return (
        <div>
            <div className={styles['flex-row']}>
                <div className={styles['col']}>
                    <div className={styles['box']}>
                        <AccountDetails />
                    </div>
                    <div className={styles['box']}>
                        <ClinicDetails userType={2} className={styles['box']}/>
                    </div>
                    <div className={styles['box']}>
                        <AssignmentRequests userType={2} />
                    </div>
                    <div className={styles['box']}>
                        <EmailPreferencesWidget />
                    </div>
                </div>
                <div className={styles['col']}>
                    <div className={styles['box']}>
                        <TreatmentSettings userType={2} className={styles['box']}/>
                    </div>
                    <HasPermission permission="account:edit">
                        <div className={`${styles['box']}`}>
                            <OpeningHours/>
                        </div>
                    </HasPermission>
                    <div className={styles['box']}>
                        <LoginsManager className={styles['box']}/>
                    </div>
                </div>
            </div>
            <HasPermission permission="user:view">
                <div className={styles['flex-row']}>
                    <div className={styles['box']}>
                        <AccountUsersTable/>
                    </div>
                </div>
            </HasPermission>
        </div>
        );
    }
}

export default ClinicAccount;
